// PRODUCTION — standalone checkbox
import React from 'react'
import {
  flowEditorCheckboxBoxCss,
  flowEditorCheckboxMarkCss,
} from 'src/pages/admin/flow-editor/flowEditorCheckboxStyles'

export const SoloCheckbox = ({
  checked,
  onChange,
  disabled = false,
}: {
  checked: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
}) => (
  <div
    role="checkbox"
    aria-checked={checked}
    aria-disabled={disabled}
    onClick={() => {
      if (!disabled) {
        onChange(!checked)
      }
    }}
    css={flowEditorCheckboxBoxCss(checked, disabled)}
  >
    {checked && (
      <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        css={flowEditorCheckboxMarkCss(disabled)}
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    )}
  </div>
)
